import { http } from '@/http'

/**
 * Gastos de vehículo de flota (DEF-ADM-015).
 * El header X-City-Id lo agrega el interceptor global.
 */
export default {
  list(params) {
    return http.get('/api/v1/fleet/expenses', { params })
  },
  summary(params) {
    return http.get('/api/v1/fleet/expenses/summary', { params })
  },
  get(id) {
    return http.get(`/api/v1/fleet/expenses/${id}`)
  },
  create(data) {
    return http.post('/api/v1/fleet/expenses', data)
  },
  update(id, data) {
    return http.put(`/api/v1/fleet/expenses/${id}`, data)
  },
  remove(id) {
    return http.delete(`/api/v1/fleet/expenses/${id}`)
  },
  // Cambio de estado: { status, notes }.
  updateStatus(id, data) {
    return http.put(`/api/v1/fleet/expenses/${id}/status`, data)
  },
  // Sube (o reemplaza) una foto. type = 'invoice' | 'reimbursement'.
  uploadPhoto(id, type, file) {
    const fd = new FormData()
    fd.append('photo', file)
    return http.post(`/api/v1/fleet/expenses/${id}/photo`, fd, { params: { type } })
  },
  // URL presigned de una foto. type = 'invoice' | 'reimbursement'.
  getPhoto(id, type) {
    return http.get(`/api/v1/fleet/expenses/${id}/photo`, { params: { type } })
  }
}
